module.exports = __webpack_public_path__ + "img/00029.3642aef1.webp";